// src/services/bi/alerts/AlertCard.jsx
import React from 'react';

const AlertCard = ({ alert, isExpanded, onToggle }) => {
  const getPriorityClass = (priority) => {
    const map = {
      critical: 'alert-card--critical',
      warning: 'alert-card--warning',
      info: 'alert-card--info',
    };
    return map[priority] || 'alert-card--info';
  };

  const getPriorityLabel = (priority) => {
    const map = {
      critical: 'Critique',
      warning: 'Avertissement',
      info: 'Information',
    };
    return map[priority] || 'Information';
  };

  return (
    <div className={`alert-card ${getPriorityClass(alert.priority)}`}>
      <div 
        className="alert-card__header"
        onClick={onToggle}
      >
        <div className="alert-card__icon-wrapper">
          <span className="alert-card__icon">{alert.icon || '⚡'}</span>
        </div>

        <div className="alert-card__header-content">
          <h4 className="alert-card__title">{alert.title}</h4>
          <p className="alert-card__description">{alert.description}</p>
        </div>

        <div className="alert-card__action">
          <span className="alert-card__priority">
            {getPriorityLabel(alert.priority)}
          </span>
          <span className={`alert-card__toggle ${isExpanded ? 'alert-card__toggle--open' : ''}`}>
            ›
          </span>
        </div>
      </div>

      {/* Contenu détaillé */}
      {isExpanded && alert.details && (
        <div className="alert-card__details">
          <div className="alert-card__details-content">
            {alert.details}
          </div>

          {/* Actions recommandées */}
          {alert.actions && alert.actions.length > 0 && (
            <div className="alert-card__actions">
              <div className="alert-card__actions-title">Actions recommandées:</div>
              <ul className="alert-card__actions-list">
                {alert.actions.map((action, index) => (
                  <li key={index} className="alert-card__action-item">
                    {action}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Métrique */}
          {alert.metric && (
            <div className="alert-card__metric">
              <span className="alert-card__metric-label">{alert.metric.label}:</span>
              <span className="alert-card__metric-value">{alert.metric.value}</span>
            </div>
          )}

          {/* Timestamp */}
          {alert.timestamp && (
            <div className="alert-card__timestamp">
              {new Date(alert.timestamp).toLocaleDateString('fr-FR', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AlertCard;